<template>

  <!-- <div id="warranty-info-content" class="support-content" v-html="supportContent"></div> -->
<div v-if="twoDiv">

 

  <div class="faq-moblie-menu-wrapper" >
       <div id="warrantyMoudule" ><img style="width:2.3em; padding-top:0.2em;" :src="require('../../assets/' +warrantyStateUrl+'.png')" @click="showyingdao()"></div>
       <div id="reviewMoudule" ><img style="width:2.5em" :src="require('../../assets/' +reviewStateUrl+'.png')" @click="showxingjipl()" ></div>
       <div id="invitedMoudule" ><img style="width:2.5em" :src="require('../../assets/' +invitedStateUrl+'.png')"  @click="showfengxiang()"> </div>
       <div id="cuMoudule"><img style="width:2.5em" :src="require('../../assets/' +cuStateUrl+'.png')"  @click="showlianxiwomeng()"></div>
       <div id="faqMoudule"><img style="width:2.5em" :src="require('../../assets/' +faqStateUrl+'.png')"  @click="showFaq1()"></div>
       <!-- <div id="faqMoudule"><img :src="require('../../assets/' +cuStateUrl+'.png')"  @click="fAQClick()"></div> -->
    </div>

  


   <div class="box-right-form-mobile" v-if="showRightForm">


                   
                <div class="box-title-mobile">
                  <img class="box-title-image" src="../../assets/shield.png" />
                  <h3 >Warranty Registration</h3>
                </div>
                <div class="box-purchasing-channel">
                  <select name="purchasing-channel" id="cc" @change="changeChannel()">
                    <option value style="display: none;"  disabled selected>Where did you buy it?      ▼</option>
                    <option value="amazon-US">Amazon US</option>
                    <option value="amazon-CA">Amazon CA</option>
                    <option value="amazon-EU">Amazon EU</option>
                    <option value="other">Other</option>
                  </select>
                  
                </div>

                <div class="eu_state_box" v-if="selectEU">
                  <select id="selectCountry">
                    <option value style="display: none;" disabled selected>Select country&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;▼</option>
                    <option v-model="radioVal" type="radio" name="state" value="UK">UK</option>
                    <option v-model="radioVal" type="radio" name="state" value="DE">DE</option>
                    <option v-model="radioVal" type="radio" name="state" value="FR">FR</option>
                    <option v-model="radioVal" type="radio" name="state" value="IT">IT</option>
                    <option v-model="radioVal" type="radio" name="state" value="ES">ES</option>
                  </select>

                </div>

                <div class="box-content-text-mobile" v-if="showBoxText">
                  <span>Get the 24 months extended warranty for free</span>
                  <div class="box-content-server">
                    <img src="../../assets/gouzi.png" />
                    <span>Activate your warranty</span>
                    <br />
                    <br />
                    <img src="../../assets/gouzi.png" />
                    <span>Get VIP customer service</span>
                    <br />
                    <br />
                  </div>
                </div>

                <div class="box-content-text-mobile" v-if="showBoxAmazon">
                  <div class="mobile-box-amazon-bt">
                    <!-- <a id="LoginWithAmazon" >
                      <img
                        border="0"
                        alt="Login with Amazon"
                        src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_156x32.png"
                        width="156"
                        height="32"
                      />
                    </a> -->
                    
                      <input type="text" id ="fristName" name="name" placeholder="Name*" />
                      <input type="text" id ="email" name="email" placeholder="Email*" />
                      <p style="margin-top:8%">Order Number*</p>
                      <input style="float:left;width:3em;margin-top:0%;border: solid 1px #CCCCCC;" type="text" id ="ordernumber1" name="ordernumber" size="3" maxlength="3" @keyup="transfer(1)"/><span style="float:left;color:#CCCCCC">—</span>
                      <input style="float:left;width:4.5em;margin-top:0%;border: solid 1px #CCCCCC;" type="text" id ="ordernumber2" name="ordernumber" size="7" maxlength="7" @keyup="transfer(2)"/><span style="float:left;color:#CCCCCC">—</span>
                      <input style="width:4.5em;margin-top:0%;border: solid 1px #CCCCCC;" type="text" id ="ordernumber3" name="ordernumber"  size="7" maxlength="7"/>
                     
                    <div id="affrim" @click="affrimRecord">SUBMIT</div>
                  </div>
                 
                </div>

                 <div class="box-content-text-mobile" v-if="showOrderFrom">
                  <div class="mobile-box-amazon-bt">
                    
                    
                      <input type="text" id ="purchaseWaysName" name="name" placeholder="Name*" />
                      <input type="text" id ="purchaseWaysEmail" name="email" placeholder="Email*" />
                      <p style="margin-top:8%">Ways to purchase?</p>
                       <textarea name="purchaseWays" id="purchaseWays" cols="20" rows="4"></textarea>
                     
                    <div id="affrim" @click="affrimRecord(1)">SUBMIT</div>
                  </div>
                 
                </div>

               

                

            </div>
               

                  <div class="box-right-form-mobile grade-mobile" v-if="showBoxGrade">
                          <div class="star-mobile" id="starMobile">
                          <img @mouseover="mouseOver(1)" 
                              @mouseleave="mouseLeave"
                              @click="starClick(1)"
                              :src="star1" >
                          <img @mouseover="mouseOver(2)" 
                              @mouseleave="mouseLeave"
                              @click="starClick(2)"
                                :src="star2">
                            <img @mouseover="mouseOver(3)" 
                              @mouseleave="mouseLeave"
                              @click="starClick(3)"
                              :src="star3" >
                          <img @mouseover="mouseOver(4)" 
                              @mouseleave="mouseLeave"
                              @click="starClick(4)"
                              :src="star4" >
                            <img @mouseover="mouseOver(5)" 
                              @mouseleave="mouseLeave"
                              @click="starClick(5)"
                              :src="star5">    
                            </div>

                      </div>


                    <div class="box-content-text from gradefrom" v-if="showBoxGrade">
                      <form action="https://api.1byonehealth.com/ap/review" method="post" id="gradefrom">
                        <input type="hidden" id="star-num" name="starnum" v-model="starNum"></input>

                          <!-- <div class="tagClass-wrapper-mobile">
                            <div class="tagClass-mobile"
                              v-for="tag in tags"
                              :key="tag.value"
                            >
                              <span  @click="tagClick(tag.value)">{{ tag.value }}</span>
                            </div>
                         </div> -->

                        <div style="width: 90%;margin-left:5%">
                          <div style="width: 65%;padding-top: 8em;">Review*</div>
                          <textarea name="Review" id="gradeReview" cols="30" rows="4"></textarea>
                        <!-- <input id="gradeReview" type="text" name="Review" placeholder="" /> -->
                        
                        <br>
                        <br>
                        <!-- <input id="gradeName" type="text" name="Name" placeholder="Name*" />
                        <input id="gradeEmail" type="text" name="email" placeholder="Email*" /> -->
                      
                        <span>To encourage customers to leave a review, we will send some of the lucky customers who leave the review a surprise bonus or cash reward</span>
                        </div>

                        <button type="button" style="margin-bottom:3em;margin-left:1em" @click="fromSubmit">SUBMIT</button>
                        <div class="after-contact-box" v-if="showAfterBox">
                          <p>How can we help?</p>
                          <p>Call: +1909-391-3888</p>
                          <p>Email: help@1byone.com</p>
                        </div>
                      </form>
                    </div>


                  <div class="share-mobile " v-if="showBoxShare">
                    <h4>Thank you for your support! </h4>
                  <!-- <h4>You are almost done! </h4>
                  <br>
                  <span>We are grateful if you are willing to share your review on Amazon. A review is the best reward for us.</span>
                  <br>
                  <br>


                  <div @click="finishedInvited()">
                    <img border="0" src="../../assets/share.png" width="281" height="61"/>
                  </div>
                  <br>
                  <br>
                  <span>The review has been copied to the clipboard.</span>
               
                  <br>
                  <br>
                  <br> -->
                </div>





                  <div class="received-mobile" v-if="showReceived">
                  <div  style="width:85%">
                  <img style="text-align:center;width:20%" src="../../assets/chenggong.png"></br>  <br>
                  <span>Your message has been successfully sent. Our team will reply you within next 48 hours.</span>
                  <br>
                  <br>
                 <br>
                </div>
                </div>

                 <div class="received-mobile" v-if="invitedfinish">
                  <div  style="width:85%">
                    <img style="text-align:center;width:20%" src="../../assets/chenggong.png"></br>  <br>
                  <span>Thanks for your feedback, you review helps us get better.</span>
                  <br>
                  <br>
                 <br>
                </div>
                </div>


                <div class="cufrom-mobile" v-if="fromcu">

                  <div class="box-text-mobile">
                          <h3><img src="../../assets/dialog.png">Need some help?</h3>
                          <span>Let us know what's going on, and we'll match you to a product specialist who will take it from here.</span>
                      </div>

              <form action="https://api.1byonehealth.com/ap/contact_info" method="post" id="selectFrom">

                     
                   
                  
                    <input id="selectFirstName" type="text" name="FirstName" placeholder="Name*" />
                    <br>
                    <br>
                     <input id="selectEmail" type="text" name="email" placeholder="Email*" />
                     <br>
                      <br>
                     
                      <span>Message*</span>
                     <textarea rows="6" cols="20" id="selectMessage" type="text" name="Review" @blur="cuUnfinish()"></textarea>
                    <br>

                    <br>
                   
                    <button type="button" @click="fromChoose">SUBMIT</button>

                    <div class="contact-way"><span>Or you can contact us here：</span></br>
                         <span>Email: help@1byone.com</span></br>
                         <span>Call: +1909-391-3888</span>
                        </div>
                    
                  </form>

            </div>

            <div id="loginsuccessful" v-if="showloginsuccessful">
                  <div id="titel-congratulations"> Congratulations</div>
                  <img id="logingouzi" src="../../assets/chenggong.png">
                  <div id="loginsuccessful-content"> you have actived your warranty!</div>
                   <div id="affrim1" @click="showxingjipl()">SUBMIT</div>
            </div>

         <!-- faq模块 -->
            <div class="faq-mobile" v-if="showFaq">
              <div style="width:90%; margin-left:5%">
                <img :src="'https://media.1byonehealth.com/image/product/'+this.spId+'/main.jpg'" width="80px" style="float:left;margin-right:15px">
                <span>Now that you're all set up,here is everything else you'll need to know</span>
              </div><br><br>

              <el-collapse>
                          
                          <el-collapse-item 
                          title="FAQ" 
                          >
                                <el-collapse>
                                <el-collapse-item 
                                  v-for="faq in faqData1"
                                  :key="faq.title"
                                  :title="faq.title" 
                                  >
                                  <div
                                    v-for="value in faq.value"
                                    :key="value.centent"
                                  >
                                    {{ value.centent }}
                                  </div>
                                </el-collapse-item>
                              </el-collapse>
                          </el-collapse-item>


                          <el-collapse-item 
                          title="TECH SPECS" 
                          >
                             <img src="../../assets/specifications.png" width="100%" alt="">
                          </el-collapse-item>

                               <el-collapse-item 
                          title="TROUBLESHOOTING" 
                          >
                             <img src="../../assets/troubleshoot.png" width="100%" alt="">
                          </el-collapse-item>

                               <el-collapse-item 
                          title="TYPICAL RESULTS" 
                          >
                             <div> <p>{{ f01Data1.TYPICALRESULTS1}}<br>{{ f01Data1.TYPICALRESULTS2}}<br>{{ f01Data1.TYPICALRESULTS3}}</p></div>
                          </el-collapse-item>

                               <el-collapse-item 
                          title="WARRANTY TERMS" 
                          >
                             <div> <p>{{ f01Data1.WARRANTYTERMS1}}<br>{{ f01Data1.WARRANTYTERMS2}}<br>{{ f01Data1.WARRANTYTERMS3}}<br>{{ f01Data1.WARRANTYTERMS4}}<br>{{ f01Data1.WARRANTYTERMS5}}<br>{{ f01Data1.WARRANTYTERMS56}}{{ f01Data1.WARRANTYTERMS7}}</p></div>
                          </el-collapse-item>

                               <el-collapse-item 
                          title="WARNINGS" 
                          >
                             <div><p>{{ f01Data1.WARNINGS_MOBILE1}}<br>{{ f01Data1.WARNINGS_MOBILE2}}<br>{{ f01Data1.WARNINGS_MOBILE3}}<br>{{ f01Data1.WARNINGS_MOBILE4}}<br>{{ f01Data1.WARNINGS_MOBILE5}}<br>{{ f01Data1.WARNINGS_MOBILE6}}<br>{{ f01Data1.WARNINGS_MOBILE7}}<br>{{ f01Data1.WARNINGS_MOBILE8}}<br>{{ f01Data1.WARNINGS_MOBILE9}}<br>{{ f01Data1.WARNINGS_MOBILE10}}<br>{{ f01Data1.WARNINGS_MOBILE11}}<br>{{ f01Data1.WARNINGS_MOBILE12}}<br>{{ f01Data1.WARNINGS_MOBILE13}}<br>{{ f01Data1.WARNINGS_MOBILE14}}<br>{{ f01Data1.WARNINGS_MOBILE15}}<br>{{ f01Data1.WARNINGS_MOBILE16}}<br>{{ f01Data1.WARNINGS_MOBILE17}}</p></div>
                          </el-collapse-item>

              </el-collapse>

                
            </div> 

            
    </div>


    
</template>


<script>
import fullStar from "../../assets/fullStar.png";
import hollowStar from "../../assets/hollowStar.png";
import supportMixins from "../../mixins/supportMixins";
import { defaultAxiosConfig } from "../../api/apiConfig";
import { faq01Data } from "../../mixins/faqData"
import { f01Data } from "../../mixins/faqData"
export default {

  data: () => ({
    warrantyStateUrl:'warranty',
    reviewStateUrl:'danbao',
    invitedStateUrl:'lianxi',
    cuStateUrl:'bangzu',
    faqStateUrl:"faq1",
    spId:null,
    
    radioVal:"UK",
    showBoxText: true,
    selectEU:false,
    showBoxCUright:true,
    showBoxAmazon: false,
    showBoxForm: false,
    showRightForm:true,
    showBoxGrade:false,
    showBoxShare:false,
    showBoxCU:false,
    showBox: false,
    showAfterBox:false,
    showboxContact:true,
    showloginsuccessful:false,
    showReceived:false,
    invitedfinish:false,
    twoDiv:true,
    showSelectProduct:true,
    fromcu:false,
    showOrderFrom:false,
    showFaq:false,

    radioVal:"UK",

    star1:hollowStar,
    star2:hollowStar,
    star3:hollowStar,
    star4:hollowStar,
    star5:hollowStar,
    starNum:0,
    tags:null,
    spUrl:null,
    ChangeUnits:"Press the UNIT button on the back of the scale to switch between lb (pounds) and kg (kilograms).Or use the APP to switch.",
    ChangeUnits1513:"Use the APP to switch, support kg/lb/st/st:lb.",


         

// faq内容
  faqData1:[],
  f01Data1:null,


     //产品评价标签
  A03tags:[
     {
       value:"Works well",
     },
     {
       value:"Great value and useful",
     },
     {
       value:"Good buy",
     },
     {
       value:"Accurate and consistent",
     }
    
  ],

    A09tags:[
     {
       value:"Works well",
     },
     {
       value:"Great value and useful",
     },
     {
       value:"Good buy",
     },
     {
       value:"Accurate and consistent",
     }
  ],

   A01tags:[
     {
       value:"Works well",
     },
     {
       value:"Great value and useful",
     },
     {
       value:"Good buy",
     },
     {
       value:"Accurate and consistent",
     }
  ],

  
  }),



    mounted () {
      
      var spId=sessionStorage.getItem("pid");

      if(spId=="A07"||spId=="A06"||spId=="A10"||spId=="A05"||spId=="A08"){
      this.faqData1 = faq01Data();
      this.f01Data1 = f01Data();
      }
     
       this.chooseSP(spId);
      if(this.spId=="A03"){
        this.tags = this.A03tags;
      }else if(this.spId=="A09"){
        this.tags = this.A09tags;
      }

      sessionStorage.removeItem("currentLocation");
      sessionStorage.setItem("currentLocation","warrantyModule");

      
    this.showMenuIcon();
      window.showdengluchenggong = this.showdengluchenggong;    // 方法赋值给window
    },
methods: {


  changeChannel() {
    if(sessionStorage.getItem("warrantyState")!=1){
      sessionStorage.removeItem("warrantyState");
        sessionStorage.setItem("warrantyState",0);
    }
    
      let ccId = document.getElementById("cc").value;
      if (ccId == "amazon-US") {
        this.asinRegion="US";
        this.selectEU=false;
        sessionStorage.removeItem("asinRegion");
        sessionStorage.setItem("asinRegion","US");
        this.showyamaxun();
      }  else if(ccId == "amazon-CA"){
        this.asinRegion="CA";
        this.selectEU=false;
        sessionStorage.removeItem("asinRegion");
        sessionStorage.setItem("asinRegion","CA");
         this.showyamaxun();
      } else if(ccId == "amazon-EU"){
        this.selectEU=true;
        this.asinRegion="EU";
        sessionStorage.removeItem("asinRegion");
        sessionStorage.setItem("asinRegion","EU");
        this.showyamaxun();
      }else if(ccId=="other"){
        this.selectEU=false;
        sessionStorage.removeItem("asinRegion");
        this.showOrderFromMethod();
      }
    },

 checkBoxFrom(type){
   var fristName;
   var email;
   var updateEmail;
   var purchaseWays;
   var ordernumber;
   var uploadOrder;


     if(type==1){
       fristName =document.getElementById("purchaseWaysName").value;
       email =document.getElementById("purchaseWaysEmail").value;
       ordernumber="";
       purchaseWays =document.getElementById("purchaseWays").value;
       
     }else{
       fristName =document.getElementById("fristName").value;
       email =document.getElementById("email").value;
       ordernumber =document.getElementById("ordernumber1").value+"-"+document.getElementById("ordernumber2").value+"-"+document.getElementById("ordernumber3").value;
       purchaseWays="Amazon "+sessionStorage.getItem("asinRegion");
    }
      
      if(sessionStorage.getItem("emailString")!=null&&sessionStorage.getItem("emailString")!=""){
        uploadOrder="2"
        updateEmail=sessionStorage.getItem("emailString");
      }
      
     
      var istrue = true;
      if(fristName==""){
         document.getElementById("fristName").style.border="1px solid red";
         document.getElementById("affrim").style.color="red";
        istrue = false;
      }else{
        istrue=true;
      } 
      if(email=="" ){
        document.getElementById("email").style.border="1px solid red"
        istrue = false;
      }else{
        istrue=true;
      }
      
    //  if(!this.checkEmail(email)){
    //    document.getElementById("email").style.border="1px solid red"
    //     istrue = false;
    //  }else{
    //     istrue=true;
    //   }
     

        if(istrue){
         
       this.$axios({
              
              
              url:  defaultAxiosConfig.baseURL+"/ap/warranty",
              method: "post",
              params: {"fristName": fristName, "email":email,"orderNumber":ordernumber,"orderPurchaseWays":purchaseWays,"product_id":this.spId,"uploadOrder":uploadOrder,"updateEmail":updateEmail,"entrance":"mobile"}
            }).then(res => {
              console.log(res);
            });

            sessionStorage.setItem("fristName",fristName);
            sessionStorage.setItem("email",email);
      return true;
      }else{
        return false;
      }
    },

    cuUnfinish(){
      sessionStorage.removeItem("cuState");
      sessionStorage.setItem("cuState","0");
    },

getItemData(showxingjipla) {
       
      amazon.Login.setClientId(
        "amzn1.application-oa2-client.614ad24b739447b5bf9ccb4412388215"
      );
      var options = { scope: "profile", response_type: "code", pkce: true };
      amazon.Login.authorize(options, function (response) {
        if (response.error) {
          alert("oauth error " + response.error);
          return;
        }

        console.info("code: " + response.code);

        amazon.Login.retrieveToken(response.code, function (response) {
          if (response.error) {
            alert("oauth error " + response.error);
            return;
          }

          console.info("Access Token: " + response.access_token);

          amazon.Login.retrieveProfile(response.access_token, function(response){
            sessionStorage.setItem("name", response.profile.Name);
            sessionStorage.setItem("amazonUserinfo", JSON.stringify(response));
          //  showdengluchenggong();
          });
        });
      });
       this.showdengluchenggong();
    },

    affrimRecord(type) {
      if(this.checkBoxFrom(type)==true){
        sessionStorage.removeItem("warrantyState");
      sessionStorage.setItem("warrantyState","1");

      if(sessionStorage.getItem("reviewState")!="1"){
        this.chooseSP(this.spId);
        this.showMenuIcon();
        this.mobileWarrantyRecord();
       this.showdengluchenggong();

      }else{
        this.chooseSP(this.spId);
          if(this.starNum>3){
              this.showfengxiang();
              this.showMenuIcon();
          }else{
             this.showlianxiwomeng();
              this.showMenuIcon();
          }

      }
      

      }
    },

    transfer(box){
      if(box==1){
        var text1=document.getElementById("ordernumber1").value;
          if(text1.length==3){
            document.getElementById("ordernumber2").focus();
          }
      }else{
         var text2=document.getElementById("ordernumber2").value;
           if(text2.length==7){
            document.getElementById("ordernumber3").focus();
          }
      }
    },

 
     mobileWarrantyRecord(){
        this.$axios({
              url: defaultAxiosConfig.baseURL+"/website/totalData",
              //  url: "http://localhost:5000/website/totalData",
              method: "post",
              params: {"location": "warranty","type": "mobile"}
            }).then(res => {
              console.log(res);
            });
     },

 

    //   显示各种盒子方法
    showyamaxun(){
      this.boxclear();
      this.showBox = true; 
      this.twoDiv=true;
      this.showRightForm=true;
      this.showBoxAmazon = true;
      
    //  this. showdengluchenggong();
      
    },

     showOrderFromMethod(){
      this.boxclear();
      this.showBox = true; 
      this.twoDiv=true;
      this.showRightForm=true;
      this.showOrderFrom = true;
      
    //  this. showdengluchenggong();
      
    },
    showdengluchenggong(){
      this.boxclear();
      this.showBox = true; 
      this.twoDiv=true;
      
      this.showloginsuccessful=true;
    },

    showfengxiang(){
      sessionStorage.removeItem("currentLocation");
      sessionStorage.setItem("currentLocation","invitedModule");
      this.showMenuIcon();


      if(sessionStorage.getItem("warrantyState")=="1"&&sessionStorage.getItem("reviewState")=="1"&&sessionStorage.getItem("invitedState")!="1"){
      sessionStorage.removeItem("invitedState");
      sessionStorage.setItem("invitedState","0");
      }
     
      
      this.boxclear();
      this.showBox = true; 
      this.showBoxCU=true;
      this.twoDiv=true;
      this.showBoxShare =true;
    },

    showqitafrom(){
      this.boxclear();
      this.showBoxForm = true;
      this.showBox = true; 
      this.twoDiv=true;
      this.showRightForm=true;
    },

    showxingjipl(){
      sessionStorage.removeItem("currentLocation");
      sessionStorage.setItem("currentLocation","reviewModule");
      this.showMenuIcon();
      this.boxclear();
      this.twoDiv=true;
      this.showBoxGrade =true;
      // this.showBox = true; 
      // this.showBoxCU=true;
      // this.showBox = true; 
      // this.showBoxCU=true;
      // this.showboxContact=true;
    },

    showlianxiwomeng(){
      sessionStorage.removeItem("currentLocation");
      sessionStorage.setItem("currentLocation","cuModule");

      this.showMenuIcon();
      this.boxclear();
      this.twoDiv=true;
      this.showBox = true; 
      this.showBoxCU=true;
      this.fromcu=true;
      // this.showBoxCUright=true;
    },

      showFaq1(){
      sessionStorage.removeItem("currentLocation");
      sessionStorage.setItem("currentLocation","faqModule");

      this.showMenuIcon();
      this.boxclear();
      this.twoDiv=true;
      this.showBox = true; 
      this.showBoxCU=true;
      this.showFaq=true;
      // this.showBoxCUright=true;
    },

    showyingdao(){
      sessionStorage.removeItem("currentLocation");
      sessionStorage.setItem("currentLocation","warrantyModule");
      

      this.showMenuIcon();
      this.boxclear();
      this.showBoxText = true;
      this.showBox = true; 
      this.twoDiv=true;
      this.showRightForm=true;
    },

    show3xinglianxi(){
        this.boxclear();
        this.showBox = true; 
      this.showBoxCU=true;
      this.showboxContact=true;
        
    },
    showfankuichenggong(){
       this.boxclear();
        this.showBox = true; 
      this.showBoxCU=true;
      this.twoDiv=true;
       this.showReceived=true;

    },
    invitedchenggong(){
       this.boxclear();
        this.showBox = true; 
      this.showBoxCU=true;
      this.twoDiv=true;
       this.invitedfinish=true;

    },
    // 清空盒子
    boxclear(){
      this.twoDiv=false,
      this.showBoxText=false,
      this.showBoxCUright=false,
      this.showBoxAmazon=false,
      this.showBoxForm=false,
      this.showRightForm=false,
      this.showBoxGrade=false,
      this.showBoxShare=false,
      this.showBoxCU=false,
      this.showBox=false,
      this.showboxContact=false,
      this.showloginsuccessful=false,
      this.showReceived=false,
      this.fromcu=false,
      this.invitedfinish=false,
      this.showOrderFrom=false,
      this.showFaq=false
    
    },

mouseOver(num){
          if(num==1){
              this.star1=fullStar;
          }else if(num==2){
              this.star1=fullStar;
              this.star2=fullStar;
          }else if(num==3){
              this.star1=fullStar;
              this.star2=fullStar;
              this.star3=fullStar;
          }
          else if(num==4){
              this.star1=fullStar;
              this.star2=fullStar;
              this.star3=fullStar;
              this.star4=fullStar;
          }else{
              this.star1=fullStar;
              this.star2=fullStar;
              this.star3=fullStar;
              this.star4=fullStar;
              this.star5=fullStar;
          }
            
        },


        mouseLeave() {
         if(this.isClick==false){
              this.star1=hollowStar;
              this.star2=hollowStar;
              this.star3=hollowStar;
              this.star4=hollowStar;
              this.star5=hollowStar;
          }
          else{
             if(this.starNum==1){
              this.star2=hollowStar;
              this.star3=hollowStar;
              this.star4=hollowStar;
              this.star5=hollowStar;
             }else if(this.starNum==2){
              this.star3=hollowStar;
              this.star4=hollowStar;
              this.star5=hollowStar;

             }else if(this.starNum==3){
              this.star4=hollowStar;
              this.star5=hollowStar;
          
             }else if(this.starNum==4){
              this.star5=hollowStar;
             }
          }
        },
      starClick(num){
        sessionStorage.removeItem("reviewState");
        sessionStorage.setItem("reviewState","0");
         this.isClick=true;
         this.starNum=num;
         if(this.starnum!=5){
           this.showAfterBox=true;
         }
         
          if(num==1){
            this.star1=fullStar;
            this.star2=hollowStar;
            this.star3=hollowStar;
            this.star4=hollowStar;
            this.star5=hollowStar;
            
            
          }else if(num==2){
            this.star1=fullStar;
            this.star2=fullStar;
            this.star3=hollowStar;
            this.star4=hollowStar;
            this.star5=hollowStar;
            
         }else if(num==3){
            this.star1=fullStar;
            this.star2=fullStar;
            this.star3=fullStar;
            this.star4=hollowStar;
            this.star5=hollowStar;
            
           
         }else if(num==4){
            this.star1=fullStar;
            this.star2=fullStar;
            this.star3=fullStar;
            this.star4=fullStar;
            this.star5=hollowStar;
             
          }else if(num==5){
            this.star1=fullStar;
            this.star2=fullStar;
            this.star3=fullStar;
            this.star4=fullStar;
            this.star5=fullStar;
           this.showAfterBox=false;
          }
        },

       randomString(len) {
　      len = len || 32;
 　　   var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
　　    var maxPos = $chars.length;
　　    var pwd = '';
　　    for (var i = 0; i < len; i++) {
　　　　pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
 　   　}
　　    return pwd;
     },

        // 星级评分的提交
    fromSubmit(){
      var gradeReview = document.getElementById("gradeReview").value;
      var name ;
      var email ;
      var uploadOrder;
      if(sessionStorage.getItem("warrantyState")!="1"){
        name="";
        email="无邮箱"+this.randomString(10);
        sessionStorage.setItem("emailString",email);
        uploadOrder="2";
      }else{
      name=sessionStorage.getItem("firstName");
      email=sessionStorage.getItem("email");
      uploadOrder="1";
      }
    

      var country;
      if(sessionStorage.getItem("asinRegion")=="EU"){
        country =this.radioVal;
      }else{
        country=sessionStorage.getItem("asinRegion");
      }
     
       var istrue = true;

       if(this.starNum==0){
          document.getElementById("starMobile").style.border="1px solid red";
          istrue =false;
          return;
       } 


   
      if(this.starNum<=3){
        if(gradeReview==""||gradeReview==null){
              document.getElementById("gradeReview").style.border="1px solid red"
              istrue = false;
              return;
            }else{
              istrue=true;
            } 


      }else{
        istrue=true;
      }

        if(istrue){
       this.$axios({
          
              url: defaultAxiosConfig.baseURL+"/ap/comment",
          //     url: "http://localhost:5000/ap/comment",
              method: "post",
              params: {"product_id":this.spId,"score": this.starNum, "review": gradeReview,"name":name,"email":email,"country":country,"uploadOrder":uploadOrder}
            }).then(res => {
              sessionStorage.removeItem("reviewState");
             sessionStorage.setItem("reviewState","1");
              console.log(res);
            });
      if(this.starNum>3){
            //  let text = document.getElementById('gradeReview');
            // text.select();
            // document.execCommand('Copy');
            sessionStorage.removeItem("reviewState");
             sessionStorage.setItem("reviewState","1");

              if(sessionStorage.getItem("warrantyState")!="1"){
              sessionStorage.removeItem("warrantyState");
              sessionStorage.setItem("warrantyState","0");
              this.showyingdao();
              this.showMenuIcon();
              return;
            }else{
              this.showfengxiang();
              this.showMenuIcon();
            }

            
           }else{
             sessionStorage.removeItem("reviewState");
             sessionStorage.setItem("reviewState","1");
              if(sessionStorage.getItem("warrantyState")!="1"){
              sessionStorage.removeItem("warrantyState");
              sessionStorage.setItem("warrantyState","0");
              this.showyingdao();
              this.showMenuIcon();
              return;
            }else{
              this.showlianxiwomeng();
              this.showMenuIcon();
            }
            
           }
      }
        },

      //联系我们提交
         fromChoose(){



      var selectproduct= this.spId;
      var Message=  document.getElementById("selectMessage").value;
      var selectFirstName=  document.getElementById("selectFirstName").value;
      // var selectLastName=  document.getElementById("selectLastName").value;
      var email=  document.getElementById("selectEmail").value;

      var country;
      if(sessionStorage.getItem("asinRegion")=="EU"){
        country =this.radioVal;
      }else{
        country=sessionStorage.getItem("asinRegion");
      }

      var istrue = true;
      if(Message==""){
        document.getElementById("selectMessage").style.border="1px solid red"
         istrue= false;
      }else{
        istrue=true;
      } 

       
      if(selectFirstName==""){
        document.getElementById("selectFirstName").style.border="1px solid red"
         istrue= false;
      }else{
        istrue=true;
      }

       if(email==""){
        document.getElementById("selectEmail").style.border="1px solid red"
         istrue= false;
      }else{
        istrue=true;
      }
     
      if(this.checkEmail(email)){
         istrue= true;
      }else{
         document.getElementById("selectEmail").style.border="1px solid red"
        istrue=false;
      }


      if(istrue){
      this.$axios({
              url: defaultAxiosConfig.baseURL+"/ap/cu",
                //  url: "http://localhost:5000/ap/cu",
              method: "post",
              params: {"product_id": selectproduct, "message": Message,"firstName":selectFirstName,"lastName":"","email":email,"country":country}
            }).then(res => {
               console.log(res);
            });
            sessionStorage.removeItem("cuState");
            sessionStorage.setItem("cuState","1");
            this.showMenuIcon();
            this.showfankuichenggong();
            }
        },

        finishedInvited(){
         
            if(sessionStorage.getItem("warrantyState")!="1"){
                this.showyingdao();
                this.showMenuIcon();
                return;
            }

            if(sessionStorage.getItem("reviewState")!="1"){
                this.showxingjipl();
                this.showMenuIcon();
                return;
            }
          window.open(this.spUrl);          
          sessionStorage.removeItem("invitedState");
          sessionStorage.setItem("invitedState","1");
            this.showMenuIcon();
          this.invitedchenggong();
        },

        checkEmail(email){
        var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
        if(reg.test(email)){
          return true;
        }else{
         return false;
        }
     },

     tagClick(value){
       if(document.getElementById("gradeReview").value==""){
          document.getElementById("gradeReview").value=value;
       }else{
          document.getElementById("gradeReview").value+=","+value;
       }
      
     }, 

     showMenuIcon(){

        var currentLocation =   sessionStorage.getItem("currentLocation");

      if(currentLocation=="warrantyModule"){
        if(sessionStorage.getItem("warrantyState")=="1"){
          this.warrantyStateUrl="warranty3"
        }else if(sessionStorage.getItem("warrantyState")=="0"){
          this.warrantyStateUrl="warranty2"
        }else{
        this.warrantyStateUrl="warranty";
        }

         if(sessionStorage.getItem("reviewState")=="1"){
          this.reviewStateUrl="review3"
        }else if(sessionStorage.getItem("reviewState")=="0"){
          
          this.reviewStateUrl="review2"
        }else{
        this.reviewStateUrl="review1";
        }

         if(sessionStorage.getItem("invitedState")=="1"){
          this.invitedStateUrl="invited3"
        }else if(sessionStorage.getItem("invitedState")=="0"){
          this.invitedStateUrl="invited2"
        }else{
        this.invitedStateUrl="invited1";
        }
         if(sessionStorage.getItem("cuState")=="1"){
          this.cuStateUrl="cu3"
        }else if(sessionStorage.getItem("cuState")=="0"){
          this.cuStateUrl="cu2"
        }else{
        this.cuStateUrl="cu1";
        }
          this.faqStateUrl="faq1"
      }else if(currentLocation=="reviewModule"){


        if(sessionStorage.getItem("warrantyState")=="1"){
          this.warrantyStateUrl="warranty3"
        }else if(sessionStorage.getItem("warrantyState")=="0"){
          this.warrantyStateUrl="warranty2"
        }else{
        this.warrantyStateUrl="warranty1";
        }

         if(sessionStorage.getItem("reviewState")=="1"){
          this.reviewStateUrl="review3"
        }else if(sessionStorage.getItem("reviewState")=="0"){
          this.reviewStateUrl="review2"
        }else{
        this.reviewStateUrl="review";
        }

         if(sessionStorage.getItem("invitedState")=="1"){
          this.invitedStateUrl="invited3"
        }else if(sessionStorage.getItem("invitedState")=="0"){
          this.invitedStateUrl="invited2"
        }else{
        this.invitedStateUrl="invited1";
        }
         if(sessionStorage.getItem("cuState")=="1"){
          this.cuStateUrl="cu3"
        }else if(sessionStorage.getItem("cuState")=="0"){
          this.cuStateUrl="cu2"
        }else{
        this.cuStateUrl="cu1";
        }
        this.faqStateUrl="faq1"

      }else if(currentLocation=="invitedModule"){

        if(sessionStorage.getItem("warrantyState")=="1"){
          this.warrantyStateUrl="warranty3"
        }else if(sessionStorage.getItem("warrantyState")=="0"){
          this.warrantyStateUrl="warranty2"
        }else{
        this.warrantyStateUrl="warranty1";
        }

         if(sessionStorage.getItem("reviewState")=="1"){
          this.reviewStateUrl="review3"
        }else if(sessionStorage.getItem("reviewState")=="0"){
          this.reviewStateUrl="review2"
        }else{
        this.reviewStateUrl="review1";
        }

         if(sessionStorage.getItem("invitedState")=="1"){
          this.invitedStateUrl="invited3"
        }else if(sessionStorage.getItem("invitedState")=="0"){
          this.invitedStateUrl="invited2"
        }else{
        this.invitedStateUrl="invited";
        }
         if(sessionStorage.getItem("cuState")=="1"){
          this.cuStateUrl="cu3"
        }else if(sessionStorage.getItem("cuState")=="0"){
          this.cuStateUrl="cu2"
        }else{
        this.cuStateUrl="cu1";
        }
        this.faqStateUrl="faq1"

      }else if(currentLocation=="faqModule"){

        if(sessionStorage.getItem("warrantyState")=="1"){
          this.warrantyStateUrl="warranty3"
        }else if(sessionStorage.getItem("warrantyState")=="0"){
          this.warrantyStateUrl="warranty2"
        }else{
        this.warrantyStateUrl="warranty1";
        }

         if(sessionStorage.getItem("reviewState")=="1"){
          this.reviewStateUrl="review3"
        }else if(sessionStorage.getItem("reviewState")=="0"){
          this.reviewStateUrl="review2"
        }else{
        this.reviewStateUrl="review1";
        }

         if(sessionStorage.getItem("invitedState")=="1"){
          this.invitedStateUrl="invited3"
        }else if(sessionStorage.getItem("invitedState")=="0"){
          this.invitedStateUrl="invited2"
        }else{
        this.invitedStateUrl="invited1";
        }
         if(sessionStorage.getItem("cuState")=="1"){
          this.cuStateUrl="cu3"
        }else if(sessionStorage.getItem("cuState")=="0"){
          this.cuStateUrl="cu2"
        }else{
        this.cuStateUrl="cu1";
        }
        
        this.faqStateUrl="faq"

      }else{

        if(sessionStorage.getItem("warrantyState")=="1"){
          this.warrantyStateUrl="warranty3"
        }else if(sessionStorage.getItem("warrantyState")=="0"){
          this.warrantyStateUrl="warranty2"
        }else{
        this.warrantyStateUrl="warranty1";
        }

         if(sessionStorage.getItem("reviewState")=="1"){
          this.reviewStateUrl="review3"
        }else if(sessionStorage.getItem("reviewState")=="0"){
          this.reviewStateUrl="review2"
        }else{
        this.reviewStateUrl="review1";
        }

         if(sessionStorage.getItem("invitedState")=="1"){
          this.invitedStateUrl="invited3"
        }else if(sessionStorage.getItem("invitedState")=="0"){
          this.invitedStateUrl="invited2"
        }else{
        this.invitedStateUrl="invited1";
        }
         if(sessionStorage.getItem("cuState")=="1"){
          this.cuStateUrl="cu3"
        }else if(sessionStorage.getItem("cuState")=="0"){
          this.cuStateUrl="cu2"
        }else{
        this.cuStateUrl="cu";
        }
        this.faqStateUrl="faq1"
      }

     },

     chooseSP(spId){
       if(spId=="A01"){
         this.spId ="A01";
          this.tags=this.A01tags;
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07FXTB52B:5";
          if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07TLW4FSB:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FXTB52B:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07FXTB52B:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07FXTB52B:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07FXTB52B:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07FXTB52B:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FXTB52B:5";
               }
           }
        }else if(spId=="A02"){
          this.spId ="A02";
         this.tags=this.A01tags;
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07WK1V886:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B081GYJ99R:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07WMTH6MT:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07WMTH6MT:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07WMTH6MT:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07WMTH6MT:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07WMTH6MT:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07WMTH6MT:5";
               }
           }
        }else if(spId=="A03"){
          this.spId ="A03";
        
          this.tags=this.A01tags;
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B08D6BJL71:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B08D6BJL71:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B089SZG65L:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B089SZG65L:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B089SZG65L:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B089SZG65L:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B089SZG65L:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B089SZG65L:5";
               }
           }
        }else if(spId=="A04"){
          this.spId ="A04";
          this.tags=this.A01tags;
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B08FQTXDKV:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B08FQTXDKV:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08FQTXDKV:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B08FQTXDKV:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B08FQTXDKV:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B08FQTXDKV:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B08FQTXDKV:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08FQTXDKV:5";
               }
           }
        }else if(spId=="A05"){
          this.spId ="A05";
         this.tags=this.A01tags;
           if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B082W5Y6QP:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B01FHELB56:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07FFSYQDM:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFSYQDM:5";
               }
           }
        }else if(spId=="A06"){
          this.spId ="A06";
         this.tags=this.A01tags;
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B0852DHR53:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07TJS77KR:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFQ7685:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07FFQ7685:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07FFQ7685:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07FFQ7685:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07FFQ7685:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFQ7685:5";
               }
           }
        }else if(spId=="A07"){
          this.spId ="A07";
         this.tags=this.A01tags;
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07XRG2SJR:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07XRG2SJR:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07P6BPHRW:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07P6BPHRW:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07P6BPHRW:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07P6BPHRW:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07P6BPHRW:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07P6BPHRW:5";
               }
           }
        }else if(spId=="A08"){
          this.spId ="A08";
          this.tags=this.A01tags;
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07XRCHY2J:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07XRCHY2J:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07XRHMZPC:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07XRHMZPC:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07XRHMZPC:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07XRHMZPC:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07XRHMZPC:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07XRHMZPC:5";
               }
           }
        }else if(spId=="B01"){
          this.spId ="B01";
          this.tags=this.A01tags;
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B08BC1DXHF:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B08BC1DXHF:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08BC1DXHF:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B08BC1DXHF:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B08BC1DXHF:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B08BC1DXHF:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B08BC1DXHF:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08BC1DXHF:5";
               }
           }
        }else if(spId=="B02"){
          this.spId ="B02";
         this.tags=this.A01tags;
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B08BF4RDWP:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B08BF4RDWP:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08BF4RDWP:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B08BF4RDWP:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B08BF4RDWP:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B08BF4RDWP:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B08BF4RDWP:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B08BF4RDWP:5";
               }
           }
        }else if(spId=="B03"){
          this.spId ="B03";
          this.tags=this.A01tags;
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B089153D4W:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B089153D4W:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B089153D4W:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B089153D4W:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B089153D4W:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B089153D4W:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B089153D4W:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B089153D4W:5";
               }
           }
        }else if(spId=="B04"){
          this.spId ="B04";
         this.tags=this.A01tags;
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B089W7H9XK:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B089W7H9XK:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B075DSY8BC:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B075DSY8BC:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B075DSY8BC:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B075DSY8BC:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B075DSY8BC:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B075DSY8BC:5";
               }
           }
        }else if(spId=="B05"){
          this.spId ="B05";
          this.tags=this.A01tags;
           if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07JG5JDD9:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
           this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07JG5JDD9:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07JG5JDD9:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07JG5JDD9:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07JG5JDD9:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07JG5JDD9:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07JG5JDD9:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07JG5JDD9:5";
               }
           }
        }else if(spId=="D01"){
          this.spId ="D01";
          this.tags=this.A01tags;
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B082Y53TCQ:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B082Y53TCQ:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07ZVV561D:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07ZVV561D:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07ZVV561D:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07ZVV561D:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07ZVV561D:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07ZVV561D:5";
               }
           }
        }else if(spId=="B06"){
          this.spId ="B06";
          this.tags=this.A01tags;
          if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B07XTFW97H:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
          this.spUrl="https://www.amazon.ca/review/create-review?&asin=B07XTFW97H:5";
           if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07XTFW97H:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07XTFW97H:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07XTFW97H:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07XTFW97H:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07XTFW97H:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07XTFW97H:5";
               }
           }
        }else if(spId=="E01"){
          this.spId ="E01";
          this.tags=this.A01tags;
         if(sessionStorage.getItem("asinRegion")=="US")
          this.spUrl="https://www.amazon.com/review/create-review?&asin=B082V7WB61:5";
           if(sessionStorage.getItem("asinRegion")=="CA")
           this.spUrl="https://www.amazon.ca/review/create-review?&asin=B082V7WB61:5";
          if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B082V7WB61:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B082V7WB61:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B082V7WB61:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B082V7WB61:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B082V7WB61:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B082V7WB61:5";
               }
           }
        }else{
           this.spId ="A05";
          this.tags=this.A01tags;
          if(sessionStorage.getItem("asinRegion")=="US")
               this.spUrl="https://www.amazon.com/review/create-review?&asin=B082W5Y6QP:5";
                if(sessionStorage.getItem("asinRegion")=="CA")
               this.spUrl="https://www.amazon.ca/review/create-review?&asin=B01FHELB56:5";
               if(sessionStorage.getItem("asinRegion")=="EU"){
               if(this.radioVal=="UK"){
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="DE"){
                    this.spUrl="https://www.amazon.de/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="FR"){
                    this.spUrl="https://www.amazon.fr/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="IT"){
                    this.spUrl="https://www.amazon.it/review/create-review?&asin=B07FFSYQDM:5";
               }else if(this.radioVal=="ES"){
                    this.spUrl="https://www.amazon.es/review/create-review?&asin=B07FFSYQDM:5";
               }else{
                    this.spUrl="https://www.amazon.co.uk/review/create-review?&asin=B07FFSYQDM:5";
               }
          }
        }
     }

  },
  metaInfo: {
    title: "Warranty | 1byone health",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "1byone health gives user free support,30-day money-back guarantee for any reason, and 12-month warranty for quality-related issues."
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "1byone, 1byone health, warranty, product warranty,30-day money-back guarantee,12-month warranty gurantee warranty, free replacement,free support"
      }
    ]
  },
  mixins: [supportMixins("WarrantyInfo")]
};
</script>


<style>
#warranty-info-content div {
  padding: 5px;
  border: 1px solid #dadada;
  border-left: 5px solid #e2211c;
}
.box-right-form-mobile {
  margin-left: 10%;
  height: 100%;
  width: 70%;
  margin-bottom: 10%;
 
}
.box-purchasing-channel {
  margin-top: 3%;
  margin-left: 10%;
  margin-bottom: 10%;
  width: 210px; /*宽度*/
  height: 30px; /*高度*/

  background: rgba(0, 0, 0, 0.2);

  border-radius: 5px;
  /* overflow: hidden; */
}
.box-content-text-mobile {
  margin-top: 5%;
  margin-left: 10%;
  width: 100%;
}
.box-title-mobile {
  margin-top: 0%;
  margin-left: 7%;
  width: 100%;
  margin-bottom: 15%;
}
.eu_state_box{
  margin-top: 1em;
  margin-left: 10%;
}
#affrim{
  color: white;
  margin-top: 10%;
  background-color: gray;
  width: 6em;
  height: 1.8em;
  text-align:center;
  border-radius:0.8em;
  margin-left: 0em;
}
#affrim1{
  color: white;
  margin-top: 10%;
  background-color: gray;
  width: 6em;
  height: 1.8em;
  text-align:center;
  margin: 0 auto; 
  border-radius:0.8em;
  
}
.warranty-title{
  margin-left: 0%;
}
.warranty-1{
  /* font-size: 0.5em; */
  width: 100%;
  margin-left: 10%;
}
.mobile-box-amazon-bt input{
  margin-top: 10%;
  margin-bottom: 5%;
  border-bottom: solid 1px #CCCCCC;
}

#loginsuccessful {
  margin-bottom: 3em;
  /* width: 65%;
 margin-left: 15%; */
 text-align: center;
}

#loginsuccessful-buttom{
 margin-bottom: 3em;
 text-align: center;
  
}
#logingouzi{
  width: 15%;
  margin-top: 8%;
  margin-bottom: 8%;
  margin-left: 0%;
}
#titel-congratulations{
 text-align: center;
}
#loginsuccessful-content{
  margin-bottom: 10%;
}
.faq-moblie-menu-wrapper {
  /* width: 4.5em;
  height: 2em;
  float: left;
    text-align: center;
    border-bottom: solid 1px 	#DCDCDC; */
    width: 100%;
    margin-left: 0%;
    float: left;
    
}

.faq-moblie-menu-wrapper div{
  margin-bottom: 10%;
  
  width: 20%;
  height: 2.7em;
  float: left;
    text-align: center;
    background-color: white;
    border-bottom: solid 1px 	#DCDCDC;
    
}

.star-mobile img{
 margin-left: 5%;
 width: 15%;

}
.v-label {
  font-size: 14px;
  color: #333333 !important;
}

.v-input--radio-group {
  height: 40px;
}

#request-type-selection-wrapper .v-input__control {
  margin: auto;
}

.tagClass-mobile{
  color: white;
  float: left;
  margin-right: 1em;
  background-color: gray;
  padding-left: 0.3em;
  padding-right: 0.3em;
  margin-top: 0.5em;
  /* width: 6em; */
  height: 1.6em;
  text-align: center;
  border-radius:6px;
  cursor:pointer;
}
.gradefrom{
  margin-left: 5%;
 
}
.gradefrom button{
  margin-left: 0%;
}
.support-form-wrapper{
  margin-bottom: 5em;
}
.grade-moble{
     width: 100%;
}
.share-mobile{
     width: 80%;
     margin-left: 10%;
}

.share-mobile h4{
     margin-left: 20%;
}
.current{
  background-color: gray;
}

.box-select-product-mobile{
  width: 70%;
   border-bottom: solid 1px ;
   border-radius: 2px;

}
.received-mobile :first-child{
  width: 80%;
  margin-left: 6%;
  
  text-align:center;
}
.tagClass-wrapper-mobile{
  margin-left: 5%;

}

.cufrom-mobile{
  margin-left: 10%;
  width: 90%;
}
.cufrom-mobile input{
  border-bottom: solid 1px #BEBEBE;
}

.cufrom-mobile button{
  background-color: gray;
  color: white;
  width: 6em;
  border-radius: 2em;
  margin-bottom: 1.5em;
}

.box-text-mobile{
 
  width: 85%;
  margin-bottom: 2em;
}

.box-text-mobile img{
  width: 6%;
  margin-right: 2%;
}
.contact-way{
  font-size: 0.85em;
  margin-bottom: 2em;
}
#selectMessage{
  border: gray 1px solid;
}
#gradeReview{
  border: gray 1px solid;
}
#selectCountry{

  /* margin-left: 10%; */
 
  width: 210px; /*宽度*/
  height: 30px; /*高度*/

  background: rgba(0, 0, 0, 0.2);
  padding-left: 0.6em;
  border-radius: 5px;
}
#purchaseWays{
   border: gray 1px solid;
   width: 90%;
}
/* .faq-mobile{
   width: 100%;
  margin-left: 0%;
  
 
} */

.faq-mobile{
  float: left;
  margin-left: 5%;
   width: 90%; 
}


</style>